import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import AllBrachofficeTable from './AllBranchofficeTable';

function BranchofficePage() {
  return (
    <ErrorBoundaries>
      <AllBrachofficeTable />
    </ErrorBoundaries>
  );
}

export default BranchofficePage;
